/* ============================================================
   YM Price Top
   Keeps #ym-price-top and #ym-variant-summary in sync with the
   selected variant, with three possible states:
     - available       -> show formatted price
     - sold out        -> .is-sold-out  (CSS renders "Uitverkocht")
     - non-existent    -> .is-unavailable (CSS renders "Uitverkocht")

   Anti-flash strategy:
   - Initial state is rendered server-side by Liquid, so no FOUC.
   - On variant change we listen to the native 'change' event on the
     radio inputs. This fires synchronously, BEFORE Shopify's
     product-info fetch completes and swaps the DOM. We compute the
     new state from pre-embedded JSON and update #ym-price-top in
     the same tick.
   - Event delegation on document means listeners survive any DOM
     swap Shopify's product-info performs.
   ============================================================ */

(function () {
  'use strict';

  var DATA_ID = 'ym-variants-data';
  var PRICE_EL_ID = 'ym-price-top';
  var SUMMARY_EL_ID = 'ym-variant-summary';

  var variantsById = null;
  var moneyFormat = '{{amount}}';

  /* ---------- data loading ---------- */

  function loadData() {
    var script = document.getElementById(DATA_ID);
    if (!script) return false;
    try {
      var parsed = JSON.parse(script.textContent || '{}');
      variantsById = parsed.variants || {};
      if (parsed.moneyFormat) moneyFormat = parsed.moneyFormat;
      return true;
    } catch (e) {
      // Parse failure: leave initial (server-rendered) state alone.
      console.warn('[ym-price-top] variants JSON parse failed', e);
      return false;
    }
  }

  /* ---------- money formatting ----------
     Uses Shopify.formatMoney if present, otherwise a minimal
     EU-style fallback (€ 12,34). This matches Shopify's money
     filter output closely enough for display purposes. */

function formatMoney(cents) {
  var euros = cents / 100;
  if (euros % 1 === 0) return '\u20AC ' + euros;
  return '\u20AC ' + euros.toFixed(2).replace('.', ',');
}

  /* ---------- reading the current selection ---------- */

  function getVariantIdFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('variant');
    } catch (e) {
      return null;
    }
  }

  function getVariantIdFromForm() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function getSelectedOptionValues() {
    var wrap = document.querySelector('.product__info-wrapper');
    if (!wrap) return [];

    var vs = wrap.querySelector('[id^="variant-selects-"]');
    if (!vs) return [];

    var values = [];
    var seen = {};

    var fieldsets = vs.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (checked && !seen[checked.name]) {
        seen[checked.name] = true;
        values.push(checked.value);
      }
    }
    return values;
  }

  /* ---------- resolving selection to a variant ---------- */

  function findVariantByOptions(optionValues) {
    if (!variantsById || !optionValues.length) return null;
    var keys = Object.keys(variantsById);
    for (var i = 0; i < keys.length; i++) {
      var v = variantsById[keys[i]];
      if (!v || !v.options || v.options.length !== optionValues.length) continue;
      var match = true;
      for (var j = 0; j < v.options.length; j++) {
        if (v.options[j] !== optionValues[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function resolveCurrentVariant() {
    // Prefer the radio selection because it reflects user intent even
    // before Shopify updates the URL / form input.
    var selectedValues = getSelectedOptionValues();
    var variant = findVariantByOptions(selectedValues);
    if (variant) return variant;

    // Fallbacks for initial page load or odd states.
    var id = getVariantIdFromUrl() || getVariantIdFromForm();
    if (id && variantsById && variantsById[id]) return variantsById[id];

    return null;
  }

  /* ---------- applying state to the DOM ---------- */

  function applyState(variant) {
    var priceEl = document.getElementById(PRICE_EL_ID);
    if (!priceEl) return;

    var summaryEl = document.getElementById(SUMMARY_EL_ID);
    var taxEls = document.querySelectorAll('.product__tax');

    priceEl.classList.remove('is-sold-out', 'is-unavailable');
    for (var i = 0; i < taxEls.length; i++) {
      taxEls[i].classList.remove('is-hidden-soldout');
    }

    if (!variant) {
      // No variant exists for this combination of options.
      priceEl.textContent = '';
      priceEl.classList.add('is-unavailable');
      hideTax(taxEls);
    } else if (!variant.available) {
      // Variant exists but is sold out.
      priceEl.textContent = '';
      priceEl.classList.add('is-sold-out');
      hideTax(taxEls);
    } else {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (summaryEl) {
      var selected = getSelectedOptionValues();
      summaryEl.textContent = selected.length ? selected.join(' | ') : '';
    }
  }

  function hideTax(taxEls) {
    for (var i = 0; i < taxEls.length; i++) {
      taxEls[i].classList.add('is-hidden-soldout');
    }
  }

  /* ---------- update orchestration ---------- */

  var pending = false;
  function scheduleUpdate() {
    if (pending) return;
    pending = true;
    // rAF keeps us in the same render frame as the user's click while
    // still letting the browser commit the :checked change first.
    requestAnimationFrame(function () {
      pending = false;
      applyState(resolveCurrentVariant());
    });
  }

  /* ---------- listeners (delegated, so DOM swaps don't matter) ---------- */

  function attachListeners() {
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      if (target.closest('[id^="variant-selects-"]')) {
        scheduleUpdate();
      }
    }, true);

    // Handle deep-linked ?variant= changes (browser back/forward, or
    // product-info pushing state after its async fetch completes).
    window.addEventListener('popstate', scheduleUpdate);

    var origPush = history.pushState;
    var origReplace = history.replaceState;
    history.pushState = function () {
      var r = origPush.apply(this, arguments);
      scheduleUpdate();
      return r;
    };
    history.replaceState = function () {
      var r = origReplace.apply(this, arguments);
      scheduleUpdate();
      return r;
    };
  }

  /* ---------- init ---------- */

  function init() {
    if (!loadData()) return;
    attachListeners();
    // Reconcile once in case the server-rendered state missed something
    // (e.g. URL ?variant= differing from first_available_variant).
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();